export const getDefaultTransactionObj = () => ({
    id: "",
    createdBy: "",
    amount: 0,
    caseInfo: "",
    type: "Paid",
    invoiceNumber: "",
    date: "",
  });